const LISTAR_DADOS = (state, payload) => {
  state.items = payload
}

const LISTAR_DELETADOS = (state, payload) => {
  state.itemsDeletados = payload
}

const CARREGANDO = (state, payload) => {
  state.carregando = payload
}

const INSERIR_PROVEDOR_SELECIONADO = (state,  payload) => {
  state.selecionado = payload
}

const DEFINIR_RELACOES_LISTAGEM = (state, payload) => {
  state.relacoesListagem = payload || []
}

export {
    LISTAR_DADOS,
    LISTAR_DELETADOS,
    CARREGANDO,
    INSERIR_PROVEDOR_SELECIONADO,
    DEFINIR_RELACOES_LISTAGEM,
}